/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-state-base: var(--background, var(--nve-sys-layer-canvas-background));
  --background: var(--nve-sys-interaction-background);
  --border-radius: var(--nve-ref-border-radius-sm);
  --padding: var(--nve-ref-space-xxs);
  --gap: var(--nve-ref-space-xxxs);
  --width: fit-content;
  --height: fit-content;
  width: var(--width);
  height: var(--height);
}

[internal-host] {
  background: var(--background);
  border-radius: var(--border-radius);
  padding: var(--padding);
  gap: var(--gap);
  overflow: hidden;
  display: flex;
  height: 100%;
  align-items: center;
}

::slotted(nve-button),
::slotted(nve-icon-button) {
  --height: var(--nve-sys-interaction-field-height);
  --border-radius: var(--nve-ref-border-radius-sm);
}

::slotted(nve-icon-button) {
  --width: var(--nve-sys-interaction-field-height);
}

::slotted(nve-divider) {
  margin-block-start: calc(-1 * var(--padding));
  height: calc(100% + var(--padding));
  --color: color-mix(in oklab, var(--nve-sys-interaction-background) 100%, var(--nve-sys-interaction-color) 50%);
}

:host([container='flat']) {
  --background: transparent;
}

:host([container='rounded']) {
  --border-radius: var(--nve-ref-border-radius-full);
}

:host([container='rounded']:not(:state(split))) ::slotted(nve-button),
:host([container='rounded']:not(:state(split))) ::slotted(nve-icon-button) {
  --border-radius: var(--nve-ref-border-radius-full);
}

:host([orientation='vertical']) {
  --gap: var(--nve-ref-space-xs);
}

:host([orientation='vertical']) [internal-host] {
  flex-direction: column;
}

:host([interaction='emphasis']) ::slotted(nve-divider) {
  --color: color-mix(
    in oklab,
    var(--nve-sys-interaction-emphasis-background) 100%,
    var(--nve-sys-interaction-emphasis-color) 50%
  );
}

:host([interaction='destructive']) ::slotted(nve-divider) {
  --color: color-mix(
    in oklab,
    var(--nve-sys-interaction-destructive-background) 100%,
    var(--nve-sys-interaction-destructive-color) 50%
  );
}

:host(:state(split)) {
  --padding: 0;
  --gap: 0;
}

:host(:state(split)) ::slotted(nve-button) {
  --border-radius: var(--nve-ref-border-radius-none);
}

:host(:state(split)) ::slotted(nve-icon-button) {
  --border-radius: var(--nve-ref-border-radius-none);
}
